import {gql, useQuery} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";

export const QUERY = gql`
query {
  pageCollection {
    items {
        slug
        slug_en_gb: slug(locale: "en-GB")
        slug_de_de: slug(locale: "de-DE")
        slug_de_ch: slug(locale: "de-CH")
        slug_de_at: slug(locale: "de-AT")
        slug_it_it: slug(locale: "it-IT")
        slug_fr_fr: slug(locale: "fr-FR")
        slug_nl_nl: slug(locale: "nl-NL")
        visibleForUserRoles
    }
  }
}`;

export const useComposePages = () => {
    const {locale} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY, {errorPolicy: "all", fetchPolicy: "cache-first"});

    const composePages = data?.pageCollection?.items;

    if (error?.message) {
        logger(error?.message, "error", "useComposePages", error?.stack);
    }

    // TODO: Suggestion: This function should wait for useQuery, instead of returning undefined, in case useQuery has not finished yet.
    // TODO: That way, we don't have to add *!composePagesLoading && composePages* on every component that uses this hook.
    const getComposePage = (route) => {
        if (!route) {
            return;
        }

        let slug = route;

        // Check trailing slashes and remove them
        slug = (slug.endsWith("/") ? slug.slice(0, -1) : slug);
        slug = (slug.startsWith("/") ? slug.substring(1) : slug);

        // Check variants for nested routes
        return composePages?.find(cp =>
            (cp[`slug_${locale.replace("-", "_")}`] === slug) ||
            (cp[`slug_${locale.replace("-", "_")}`] === `/${slug}`) ||
            (cp[`slug_${locale.replace("-", "_")}`] === `/${slug}/`)
        );
    };

    return {
        composePages,
        composePagesLoading: loading,
        composePagesError: error,
        getComposePage,
    };
};
